import type { DestinationAddressAppParam } from '@onramp/shared/appParams.schema';
import { dedupe } from '@onramp/utils/dedupe';
import { isNotNullish } from '@onramp/utils/types';

import type { DestinationWalletDetails } from './types';

export function transformToDestinationWalletDetails(
  destinationWallets: DestinationAddressAppParam[],
): DestinationWalletDetails[] {
  return destinationWallets.map((destinationWallet) => {
    const allNetworks = dedupe(
      [
        ...(destinationWallet.blockchains || []),
        ...(destinationWallet.supportedNetworks || []),
      ].filter(isNotNullish),
    );

    const assetIds = dedupe(destinationWallet.assets || []).filter(isNotNullish);

    return {
      address: destinationWallet.address,
      assetIds,
      networks: allNetworks,
    };
  });
}

// Can be deleted after init params are validated. This function is just to help get functionality down. See https://github.cbhq.net/payments/onramp-widget/pull/2035.
export function parseDestinationWalletsAppParam(destinationWallets: unknown) {
  if (destinationWallets && typeof destinationWallets === 'string') {
    // from query string params
    return JSON.parse(destinationWallets) as DestinationAddressAppParam[];
  }
  // from secure init
  return destinationWallets as DestinationAddressAppParam[];
}
